/**
 * API 관련 설정
 * API 기본 URL 및 기타 설정을 관리합니다.
 */

// API 기본 URL
export const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/${import.meta.env.VITE_BASE_PATH}`;

// API 타임아웃 설정 (밀리초)
export const API_TIMEOUT = 30000;

// API 재시도 설정
export const API_RETRY = {
  maxRetries: 3,
  retryDelay: 1000,
};
